import Marquee from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="mt-20 border-y border-line py-6">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((w, i) => (
          <span key={i} className="font-display mx-8 flex items-center gap-8 text-3xl font-bold uppercase tracking-tight text-ink/15 sm:text-5xl">
            {w}
            <span className="h-2.5 w-2.5 rounded-full bg-gradient-to-br from-violet-400 to-pink-400" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
